// extracted by mini-css-extract-plugin
module.exports = {"benefits":"benefits-module--benefits--2wIut","container":"benefits-module--container--3IOVO","item":"benefits-module--item--3LiKK","circle":"benefits-module--circle--2hpU_"};